export default __webpack_public_path__ + "static/media/b0708865ab81bcb05d883a55fd5999241581602055913.6bc33cf6.webp";